import React, { forwardRef, useState } from 'react';
import { IconEye } from '@tabler/icons-react';
import PropTypes from 'prop-types';
import MonographModal from './Monograph/PregnancyMonographModal';
import drugsApiService from '../../../../services/drugsapi.service';
import COLOR_MAP from '../../../../constants/color-mapping';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const PregnancyPrecautions = forwardRef(function (
  { pregnancyPrecautions },
  ref,
) {
  const [showModal, setShowModal] = useState(false);
  const [monoGraphData, setMonoGraphData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFetchMonograph = async (precautionId) => {
    setLoading(true);
    try {
      const data = await drugsApiService.getPregnancyMonograph(precautionId);

      setMonoGraphData(data);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching monograph:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      ref={ref}
      className="mb-36 scroll-offset"
      id="pregnancy-precautions-section"
    >
      <h4>Pregnancy Precautions</h4>
      <div className="accordion-body">
        {pregnancyPrecautions?.Pregnancy_Precautions?.length ? (
          <div>
            <ul className="indicator">
              {pregnancyPrecautions.Pregnancy_Precautions.map(
                (pregnancyPrecaution, index) => (
                  <div key={`pregnancy-precaution-${index}`}>
                    <li className="f-18 font-semibold">
                      {pregnancyPrecaution.PrecautionsPregnancyDesc}
                    </li>
                    <div className="">
                      <div className="row">
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>
                            Severity Description
                            <PopoverInfoIcon
                              popoverInfo={COLOR_MAP.PregnancyPrecautions}
                            />
                          </label>
                          <p>
                            <span
                              className={
                                COLOR_MAP.PregnancyPrecautions[
                                  pregnancyPrecaution.SeverityDesc
                                ]
                              }
                            />
                            {pregnancyPrecaution.SeverityDesc}
                          </p>
                        </div>
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>Monograph </label>
                          <button
                            type="button"
                            className="btn view-btn mt-2"
                            onClick={() =>
                              handleFetchMonograph(
                                pregnancyPrecaution.MonographID,
                              )
                            }
                            disabled={loading}
                          >
                            <IconEye size={18} className="ti ti-eye" />
                            {loading ? 'Loading...' : 'View'}
                          </button>
                        </div>
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>Precautions Description</label>
                          <p>{pregnancyPrecaution.Narrative}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              )}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
      <MonographModal
        show={showModal}
        onHide={() => setShowModal(false)}
        monoGraphData={monoGraphData}
        loading={loading}
      />
    </div>
  );
});

PregnancyPrecautions.propTypes = {
  pregnancyPrecautions: PropTypes.object.isRequired,
};
PregnancyPrecautions.displayName = 'PregnancyPrecautions';

export default PregnancyPrecautions;
